import PropTypes from 'prop-types'
/* eslint react/self-closing-comp: 0 */

import React, { Component } from 'react'
import styles from './_routeSearchResults.css'
import { FormattedDistance } from 'shared/units'
import { FormattedMessage, FormattedDate } from 'react-intl'
import classnames from 'classnames'
import Svg from 'components/util/Svg'
import Loader from 'components/util/Loader'
import { ICON_BASE_URL } from 'components/routes/search/constants'

export class RouteSearchResults extends Component {

  static propTypes = {
    results: PropTypes.array,
    totalCount: PropTypes.number,
    unitPreference: PropTypes.shape({
      distanceUnit: PropTypes.string,
      elevationUnit: PropTypes.string,
    }),
    selectRouteAction: PropTypes.func,
    selectedRouteId: PropTypes.string,
    sortRoutesByDateAction: PropTypes.func,
    searchLoading: PropTypes.bool,
  }

  state = {
    thumbnailToDisplay: null,
    showOldest: false,
  }

  toggleThumbnail = (routeId) => {
    this.setState({
      thumbnailToDisplay: routeId,
    })
  }

  handleSelectRoute = (routeId, e) => {
    if (e.nativeEvent.target.tagName.toLowerCase() !== 'a') {
      this.props.selectRouteAction(routeId)
    }
  }

  handleSortRoutesByDate = () => {
    const { showOldest } = this.state
    this.props.sortRoutesByDateAction(!showOldest)

    this.setState({
      showOldest: !showOldest,
    })
  }

  render () {
    const {
      results,
      totalCount,
      unitPreference,
      selectedRouteId,
      searchLoading,
    } = this.props

    const { thumbnailToDisplay, showOldest } = this.state

    return (
      <section className={styles.searchResultsContainer}>
        <h3 className={styles.routeCount}>
          <span className={styles.routeCountTotal}>{totalCount}</span>
          {(totalCount !== 1) ? 'Routes' : 'Route'}
        </h3>
        <table className={styles.tableContainer}>
          <thead>
            <tr>
              <th></th>
              <th><FormattedMessage id='routesearch.result.distance' defaultMessage='Distance' /></th>
              <th className={styles.ascentCell}><FormattedMessage id='routesearch.result.ascent' defaultMessage='Ascent' /></th>
              <th><FormattedMessage id='routesearch.result.name' defaultMessage='Name' /></th>
              <th><FormattedMessage id='routesearch.result.city' defaultMessage='City' /></th>
              <th className={styles.dateCell} onClick={() => this.handleSortRoutesByDate()}>
                <FormattedMessage id='routesearch.result.date' defaultMessage='Date' />
                <Svg name='select_down' className={classnames(styles.dateArrow, {
                  [styles.dateArrowUp]: showOldest,
                })} />
              </th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, i) => {
              const routeId = result._links.self[0].id
              const thumbnail = <img className={styles.thumbnail} src={`${result._links.thumbnail[0].href}`} />
              const markerImage = (routeId === selectedRouteId) ? 'selected' : 'default'

              return (
                <tr className={styles.resultRow} key={i} onClick={(e) => this.handleSelectRoute(routeId, e)}>
                  <td className={styles.iconCell}>
                    <img
                      className={styles.icon}
                      src={`${ICON_BASE_URL}/${markerImage}_color/${i + 1}.png`} />
                  </td>
                  <td>
                    <FormattedDistance
                      digits={2}
                      value={result.distance}
                      from={'meter'}
                      to={unitPreference.distance} />
                  </td>
                  <td className={styles.ascentCell}>
                    <FormattedDistance
                      value={result.total_ascent}
                      from={'meter'}
                      to={unitPreference.elevation} />
                  </td>
                  <td className={styles.thumbnailCell}>
                    <a
                      href={`/routes/view/${routeId}`}
                      onMouseOver={() => this.toggleThumbnail(routeId)}
                      onMouseOut={() => this.toggleThumbnail(null)}>
                      {result.name}
                    </a>
                    {(thumbnailToDisplay === routeId) ?
                      <div className={styles.thumbnailContainer}>
                        {thumbnail}
                      </div>
                    : null}
                  </td>
                  <td>{result.city}</td>
                  <td><FormattedDate value={result.created_datetime} /></td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {searchLoading ?
          <div className={styles.loadingOverlay}>
            <Loader type='spin' height={40} width={40} />
          </div>
        : null}
      </section>
    )
  }
}

export default RouteSearchResults



// WEBPACK FOOTER //
// ./src/components/routes/search/RouteSearchResults.jsx